import { ActionBar, ExternalLink, PrimaryButton, SafeHtml, T2 } from 'ia-react-core';
import styled from 'styled-components';

export const StyledSafeHtml = styled(SafeHtml)`
  font-size:17px;
`;

export const StyledActionBar = styled(ActionBar)`
  margin-top: 36px;
  padding-top: 0;
`;

export const StyledButton = styled(PrimaryButton)`
  margin: 0;
`;

export const StyledT = styled(T2)`
  margin-bottom: 24px;
`;

export const StyledLink = styled(ExternalLink)`
  margin-top:17px;
  font-size:17px;
`;
